module.exports = __webpack_public_path__ + "2721dc1494dcd9e50fa3135574253334.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/big-wig.png
// module id = 2775
// module chunks = 0